import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import { ApiService } from 'src/app/services/api.service';
import { EmployeeService } from '../employee/services/employee.service';
import { Employee } from '../employee/services/employee.modal';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidatorsService } from 'src/app/services/validators.service';
import { ToastService } from 'src/app/services/toast.service';
import { MaxLength, ToastType } from 'src/app/enums/enums';
import { PhonenumberPipe } from 'src/app/pipes/phonenumber.pipe';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
  IsLoading: boolean = false;
  UserDetails!: Employee;
  ShowPasswords: boolean = false;
  public MaxPhoneLength = MaxLength.Phone;
  public MaxZipLength = MaxLength.Zip;
  public SelectedTabIndex = 1;

  constructor(
    public sharedService: SharedService,
    public apiService: ApiService,
    private employeeService: EmployeeService,
    private validatorService: ValidatorsService,
    private toastService: ToastService,
    private phoneNumberPipe: PhonenumberPipe
  ) {}

  PasswordForm: FormGroup = new FormGroup({
    oldPassword: new FormControl('', [Validators.required]),
    newPassword: new FormControl('', [
      Validators.required,
      Validators.minLength(8),
      Validators.maxLength(16),
      this.validatorService.uppercaseValidator(),
      this.validatorService.lowercaseValidator(),
      this.validatorService.numberValidator()
    ]),
    confirmPassword: new FormControl('')
  });

  EditProfileForm: FormGroup = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    phoneNumber: new FormControl('', [Validators.required])
  });

  ngOnInit(): void {
    this.IsLoading = true;
    if (this.sharedService.UserDetails.value?.userId) {
      const result = this.employeeService.GetEmployee(this.sharedService.UserDetails.value.userId);
      result.subscribe({
        next: (res) => {
          this.UserDetails = res.result;
          const { id, userId, title, email, roleId, clinicId, ...rest } = res.result;
          this.EditProfileForm.setValue(rest);
        },
        error: (err) => {
          console.log(err);
        },
        complete: () => {
          this.IsLoading = false;
        }
      });
    }
  }

  UpdateEmployee() {
    if (this.EditProfileForm.valid) {
      this.EditProfileForm.value.phoneNumber = this.phoneNumberPipe.transform(this.EditProfileForm.value.phoneNumber, 'unformat');
      const requestBody = {
        userId: this.UserDetails.userId,
        roleId: this.UserDetails.roleId,
        clinicId: this.UserDetails.clinicId,
        title: this.UserDetails.title,
        ...this.EditProfileForm.value
      };
      const response = this.employeeService.UpdateEmployee(requestBody);
      this.IsLoading = true;
      response.subscribe({
        next: (res) => {
          this.sharedService.UserDetails.next(res.result);
          this.toastService.showToast({
            message: res.message,
            type: ToastType.Success
          });
        },
        error: (err) => {
          this.IsLoading = false;
        }
      });
    } else {
      console.log('Form is invalid');
    }
  }

  ChangePassword() {
    const confirmPwd = this.PasswordForm.get('confirmPassword')?.value;
    const newPwd = this.PasswordForm.get('newPassword')?.value;
    const OldPwd = this.PasswordForm.get('oldPassword')?.value;

    if (confirmPwd === newPwd) {
      if (OldPwd === newPwd) {
        this.toastService.showToast({
          type: ToastType.Warning,
          message: 'Your New password Must be different form your Older password!'
        });
      } else {
        const response = this.employeeService.ChangePassword(this.PasswordForm.value);
        response.subscribe({
          next: (res) => {
            this.toastService.showToast({ type: ToastType.Success, message: res.message });
            this.PasswordForm.reset();
          },
          error: (err) => {},
          complete: () => {}
        });
      }
    } else {
      this.toastService.showToast({
        type: ToastType.Warning,
        message: 'Your New password and Re-entered password should be same.!'
      });
    }
  }
}
